var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"student-progress__bar"},[_c('div',{ref:"outer",staticClass:"progress-outer"},[_c('div',{ref:"inner",staticClass:"progress-inner",style:(_vm.innerStyle)})])])}
var staticRenderFns = []

export { render, staticRenderFns }